<template>
    <SoliForm
        ref="form"
        v-model="valid"
        :title="`Update ${membershipPrice.name}`"
        :saveChanges="valid && currentPrice.id !== form.newPriceId"
        textSubtitle="Mass update price for all selected memberships"
        persistent
        @success="$emit('success')"
        @reset="$emit('reset')"
        @submit="submit"
    >
        <template #body>
            <div class="flex flex-col gap-4">
                <v-select
                    v-model="form.newPriceId"
                    :rules="rules.select"
                    :error-messages="errors.newPriceId"
                    outlined
                    dense
                    class="soli-round"
                    label="Select Price"
                    error-message="errors.price"
                    item-text="formatAmount"
                    item-value="id"
                    hide-details="auto"
                    :items="locationPrices"
                />
                <v-currency-field
                    v-if="form.newPriceId === 0"
                    v-model="form.inlinePrice"
                    :rules="priceRules"
                    :error-messages="errors.inlinePrice"
                    outlined
                    dense
                    class="soli-round"
                    label="Custom Price"
                    error-message="errors.amount"
                    prepend-inner-icon="attach_money"
                    hide-details="auto"
                />
                <div
                    v-if="
                        form.newPriceId !== currentPrice.id &&
                        ((form.newPriceId === 0 && form.inlinePrice !== null) ||
                            form.newPriceId)
                    "
                    class="soli-grey text-subtitle-2"
                >
                    <p class="px-1 mb-4">
                        This will update the recurring monthly price for all
                        selected memberships, effective on their next billing
                        cycle. No proration will be charged.
                    </p>
                    <!--<v-text-field
                        v-model="form.understand"
                        :rules="[
                            (v) =>
                                v === 'CONFIRM' ||
                                'Please type CONFIRM to proceed',
                        ]"
                        rounded
                        outlined
                        dense
                        label="Please type CONFIRM to proceed"
                        hide-details="auto"
                    />-->
                    <v-checkbox
                        v-model="form.understand"
                        :rules="rules.select"
                        label="I Understand"
                        hide-details="auto"
                        class="mt-0"
                    />
                </div>
            </div>
        </template>
    </SoliForm>
</template>

<script>
import SoliForm from "./../Base/SoliForm.vue";

export default {
    props: {
        membershipPrice: {
            type: Object,
            default: () => {},
        },
        purchaseOptions: {
            type: Array,
            default: () => [],
        },
        errors: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                newPriceId: this.membershipPrice.price_id,
                currentPriceId: this.membershipPrice.price_id,
                inlinePrice: null,
                purchaseOptionIds: this.purchaseOptions.map(
                    (option) => option.id
                ),
                understand: false,
            }),
            valid: false,
            rules: SoliForm.formRules,
            priceRules: [
                (v) => !v || v > 0 || "Price must be greater than $0",
                (v) => !v || v <= 500 || "Price can't be greater than $500",
                (v) => (v || "").length > 0 || "Price is required",
            ],
        };
    },
    computed: {
        currentPrice() {
            return {
                id: this.membershipPrice.price_id,
                formatAmount: this.membershipPrice.format_amount,
                duration: this.membershipPrice.duration,
            };
        },
        locationPrices() {
            return [
                ...new Set([
                    this.currentPrice,
                    ...this.membershipPrice.product.prices.filter(
                        (price) => price.duration == this.currentPrice.duration
                    ),
                    {
                        id: 0,
                        formatAmount: "Create Custom Price",
                    },
                ]),
            ];
        },
    },
    methods: {
        async submit() {
            if (!this.valid) {
                this.$refs.form.loading = false;
                return;
            }

            const options = {
                preserveState: true,
                preserveScroll: true,
                onSuccess: () => {
                    this.$refs.form.reset();
                    this.$emit("success");
                },
                onError: (errors) => {
                    console.log(
                        "Form returned errors: " + JSON.stringify(errors)
                    );
                    this.$refs.form.loading = false;
                },
            };

            this.form
                .transform((data) => ({
                    ...data,
                    inlinePrice: data.inlinePrice
                        ? Math.round(data.inlinePrice * 100)
                        : null,
                }))
                .put(`/subscription/batch-update-price`, options);
        },
    },
    mounted() {
        this.formCopy = JSON.stringify(this.form.data());
    },
};
</script>
